"use client";

import React from "react";
import { CircleCheck, Handshake } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
const tabsData = [{
  id: "collective-bargaining",
  title: "PRIMARIA-E.S.O.-\u00A0 BACHILLER-UNIVERSITARIO",
  icon: Handshake,
  image: "https://centrocosmos.es/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-22-at-12.37.55.jpeg?v=hg7w4fwd0xk",
  description: "Abarcamos todas las asignaturas de estos niveles",
  services: ["PRIMARIA", "Desarrollo Backend Escalable", "Gestión de Bases de Datos", "Despliegue y Cloud Computing"],
  grid_cols_left: 6,
  grid_cols_right: 4,
  testimonial: {
    quote: "Gracias a CENTRO COSMOS, pasé de no saber nada de código a trabajar como desarrollador junior en solo seis meses. La metodología es impecable.",
    author: "Carlos R.",
    role: "Estudiante de Fullstack"
  }
}];
export default function LegalAndProfessionalSupport() {
  return <section data-section-id="233285" id="programas-de-formación" className="bg-background text-foreground py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiMwMDAiLz4KPC9zdmc+')]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default tracking-tighter mb-6 uppercase">
            Programas de <span className="text-primary">&nbsp;Formación</span>
          </h2>
          <p className="text-lg text-muted-foreground font-default">Clases en grupo o individuales para entenderlo todo y aprobar a la primera. Nuestro método funciona.&nbsp;</p>
        </div>

        <Tabs defaultValue={tabsData[0].id} className="w-full max-w-5xl mx-auto">
          <div className="flex justify-center mb-8 md:mb-12">
            <TabsList className="grid w-full max-w-md grid-cols-2 h-auto p-1 bg-muted border border-border rounded-lg">
              {tabsData.map((tab, index) => {
              const Icon = tab.icon;
              return <TabsTrigger key={tab.id} value={tab.id} data-index={index} className="px-2 py-1 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring text-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 border border-transparent whitespace-nowrap focus-visible:ring-[3px] focus-visible:outline-1 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 font-default font-bold text-sm data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-lg transition-all rounded-md ![padding:12px_16px_12px_16px] !w-[419px] dark:data-[state=active]:text-foreground dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 dark:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 md:text-base">
                    <Icon className="w-4 h-4 mr-2 hidden sm:inline-block" />
                    {tab.title}
                  </TabsTrigger>;
            })}
            </TabsList>
          </div>

          {tabsData.map((tab, index) => <TabsContent key={tab.id} value={tab.id} data-index={index} className="mt-0 focus-visible:outline-none focus-visible:ring-0">
              <div className="grid grid-cols-1 lg:grid-cols-10 gap-8 items-start">
                {}
                <div className="space-y-8" style={{
              gridColumn: "span " + tab.grid_cols_left
            }}>
                  <div className="relative aspect-video overflow-hidden rounded-xl border border-border shadow-xl bg-muted">
                    <img src={tab.image} data-wvc-srcset={`${tab.image}-wvc-srcset`} data-wvc-sizes={`${tab.image}-wvc-sizes`} alt={tab.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent"></div>
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="font-bold font-default text-foreground mb-2 !text-xs">{tab.title}</h3>
                      <p className="text-sm font-default max-w-lg text-foreground">{tab.description}</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    {tab.services.map((service, sIndex) => <div key={sIndex} data-index={sIndex} className="flex items-start gap-3 p-4 rounded-lg bg-card border border-border shadow-sm hover:shadow-md transition-shadow">
                        <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="font-default text-sm font-medium text-card-foreground">{service}</span>
                      </div>)}
                  </div>
                </div>

                {}
                <div className="space-y-6" style={{
              gridColumn: "span " + tab.grid_cols_right
            }}>
                  <div className="p-6 rounded-xl bg-accent text-accent-foreground border border-border text-center sm:text-left flex flex-col sm:flex-row items-center justify-between gap-6 shadow-md">
                    <div>
                      <h4 className="font-default font-bold text-xl mb-1">¿Listo para empezar?</h4>
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>)}
        </Tabs>
      </div>
    </section>;
}